export const faq = [
  {
    id: 'q-conventionne',
    question: 'Êtes-vous conventionné Sécurité Sociale ?',
    answer:
      "Oui, le cabinet est conventionné en secteur 1. Tous les soins remboursables sont pris en charge par l'Assurance Maladie selon les tarifs conventionnels. Pensez à apporter votre carte Vitale et votre carte de mutuelle à chaque rendez-vous.",
  },
  {
    id: 'q-tiers-payant',
    question: 'Pratiquez-vous le tiers payant ?',
    answer:
      "Oui, nous pratiquons le tiers payant sur la part Sécurité Sociale pour la majorité des soins courants. Pour la part mutuelle, cela dépend de votre contrat et de notre convention avec votre organisme complémentaire.",
  },
  {
    id: 'q-rendez-vous',
    question: 'Comment prendre rendez-vous ?',
    answer:
      "Vous pouvez prendre rendez-vous en ligne via le bouton « Prendre rendez-vous » (Doctolib partenaire) ou par téléphone au 03 21 79 30 20. Pour une première consultation, prévoyez environ 30 à 45 minutes.",
  },
  {
    id: 'q-urgences',
    question: 'Acceptez-vous les urgences dentaires ?',
    answer:
      "Oui, nous nous efforçons de recevoir les urgences dans la journée. En cas de douleur aiguë, contactez-nous le matin dès l'ouverture pour obtenir un créneau. Hors heures d'ouverture, contactez le 15 ou consultez le service de garde des chirurgiens-dentistes du Pas-de-Calais.",
  },
  {
    id: 'q-enfants',
    question: 'Recevez-vous les enfants ?',
    answer:
      "Oui, nous accueillons les patients de tout âge, dès la première dent. Les premières visites sont l'occasion d'un examen préventif et de conseils d'hygiène adaptés à l'âge de l'enfant.",
  },
  {
    id: 'q-implants-prix',
    question: "Combien coûte un implant dentaire ?",
    answer:
      "Le tarif d'un implant dentaire varie selon la situation clinique (nombre d'implants, greffe osseuse éventuelle, type de prothèse). Un devis détaillé est systématiquement remis avant tout traitement, ainsi qu'une estimation du remboursement Sécurité Sociale et de votre mutuelle.",
  },
  {
    id: 'q-orthodontie',
    question: "Quelle différence entre orthodontie traditionnelle et gouttières transparentes ?",
    answer:
      "L'orthodontie traditionnelle (bagues fixes) reste la solution la plus polyvalente, notamment pour les cas complexes. Les gouttières transparentes amovibles sont plus discrètes et confortables, et conviennent à de nombreux cas chez l'adulte. Nous fabriquons les gouttières directement au cabinet pour un suivi optimal.",
  },
  {
    id: 'q-acces',
    function: 'Accès & stationnement',
    question: "Comment accéder au cabinet ? Y a-t-il un parking ?",
    answer:
      "Le cabinet se trouve au 75 Avenue Régis Pollet, 62970 Courcelles-lès-Lens, à 5 minutes de Lens et Hénin-Beaumont. Stationnement gratuit possible dans la rue. Le cabinet est accessible aux personnes à mobilité réduite (PMR).",
  },
];
